module.exports = __webpack_public_path__ + "e8939a44aed38b57ccb91aab310eab5b.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture.png
// module id = 419
// module chunks = 0